import React from "react";

export interface WeekAvailability {
  dateRange: string;
  bars: { color: string; height: number; label: string }[];
}


const Y_LABELS = ["100%", "75%", "50%", "25%", "0%"];
const ROW_H = 18;
const GAP = 0;
const GRID_H = Y_LABELS.length * ROW_H + (Y_LABELS.length - 1) * GAP;
/** Pixel height from the 0% line to the 100% line */
const BAR_AREA = GRID_H - ROW_H; // bottom of first row = 100% line

export function AvailabilityChart({ week }: { week: WeekAvailability }) {
  return (
    <div className="flex flex-col" style={{ width: 196 }}>
      <div
        className="flex flex-row justify-between"
        style={{ padding: "0 4px", height: 15 }}
      >
        {week.dateRange.split(" - ").map((d, i) => (
          <span
            key={i}
            style={{
              fontFamily: "Poppins",
              fontWeight: 500,
              fontSize: 10,
              color: "#A1A1A1",
            }}
          >
            {d}
          </span>
        ))}
      </div>

      <div className="flex flex-row" style={{ height: GRID_H }}>
        <div className="flex flex-col" style={{ width: 30, gap: GAP }}>
          {Y_LABELS.map((label) => (
            <div
              key={label}
              className="flex items-end justify-end"
              style={{
                height: ROW_H,
                borderBottom: "1px solid #EAEAEA",
                fontFamily: "Poppins",
                fontWeight: 500,
                fontSize: 10,
                color: "#D9D9D9",
                textAlign: "right",
              }}
            >
              {label}
            </div>
          ))}
        </div>

        <div className="flex-1 relative">
          <div className="absolute inset-0 flex flex-col" style={{ gap: GAP }}>
            {Y_LABELS.map((_, i) => (
              <div
                key={i}
                style={{ height: ROW_H, borderBottom: "1px solid #EAEAEA" }}
              />
            ))}
          </div>

          <div
            className="absolute bottom-0 left-0 right-0 flex flex-row items-end"
            style={{ height: BAR_AREA, padding: "0 4px", gap: 4 }}
          >
            {week.bars.map((bar, i) => (
              <div
                key={i}
                title={`${bar.label} : ${bar.height}% dispo`}
                style={{
                  flex: 1,
                  maxWidth: 21,
                  height: Math.max(Math.round((bar.height / 100) * BAR_AREA), 3),
                  background: bar.color,
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.15)",
                  borderRadius: 2,
                  margin: "0 auto",
                  cursor: "default",
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
